/**
 * Update the userSettings piece of the state.
 * @param {Object} state - The current state.
 * @param {Object} action - Details of the request to the reducer being made.
 * @return {Object} The new state.
*/

export default function updateUserSettings(state, action) {
  return Object.assign({}, state, {
    userSettings: {
      ...state.userSettings,
      ...action.updates
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/updateUserSettings.js